import request from '@/utils/request'

// 查询分类
export function getCategory(data = {}) {
    return request({
        url: '/equipment/product/getCategory',
        method: 'post',
        data
    })
}


// 查询分类对应属性
export function cateProductParam(data) {
    return request({
        url: '/equipment/productCategory/detail',
        method: 'post',
        data
    })
}

// 添加商品
export function addProduct(data) {
    return request({
        url: '/equipment/product/addProduct',
        method: 'post',
        data
    })
}

// 商品详情
export function getProductDetail(data) {
    return request({
        url: '/equipment/product/detail',
        method: 'post',
        data
    })
}


// 一键估价
export function oneValuation(data) {
    return request({
        url: '/equipment/product/oneValuation',
        method: 'post',
        data
    })
}


// 编辑商品
export function editProduct(data) {
    return request({
        url: '/equipment/product/editProduct',
        method: 'post',
        data
    })
}


// 删除商品
export function deleteProduct(data) {
    return request({
        url: '/equipment/product/deleteProduct',
        method: 'post',
        data
    })
}


// 设置运费
export function setPostage(data) {
    return request({
        url: '/equipment/product/setPostage',
        method: 'post',
        data
    })
}


// 商品改价
export function changePrice(data) {
    return request({
        url: '/equipment/product/changePrice',
        method: 'post',
        data
    })
}

// 上下架
export function changeStatus(data) {
    return request({
        url: '/equipment/product/changeStatus',
        method: 'post',
        data
    })
}

// 查询我的商品列表
export function getProductList(query) {
    return request({
        url: '/equipment/product/list',
        method: 'get',
        params: query
    })
}

// 收藏商品或企业
export function collect(data) {
    return request({
        url: '/equipment/collect/collect',
        method: 'post',
        data

    })
}

// 添加对比设备
export function addProductDiff(data) {
    return request({
        url: '/equipment/memberProductDiff/add',
        method: 'post',
        data

    })
}

// 对比设备列表
export function productDiffList(data) {
    return request({
        url: '/equipment/memberProductDiff/list',
        method: 'post',
        data

    })
}
// 对比设备删除
export function deleteProductDiff(data) {
    return request({
        url: '/equipment/memberProductDiff/delete',
        method: 'post',
        data

    })
}

// 获取对比结果
export function getDiffResult(data) {
    return request({
        url: '/equipment/memberProductDiff/getResult',
        method: 'post',
        data

    })
}


// 根据商品分类获取商品列表
export function getProductByCategory(data) {
    return request({
        url: '/equipment/product/getProductByCategory',
        method: 'post',
        data

    })
}

// 搜索
export function productSearch(data) {
    return request({
        url: '/equipment/product/select',
        method: 'post',
        data
    })
}



// 删除订单
export function delOrders(data) {
    return request({
        url: '/equipment/memberOrderProduct/deleteOrder',
        method: 'post',
        data
    })
}

//建材单位
export function getUnit(data) {
    return request({
        url: '/equipment/product/getUnit',
        method: 'post',
        data
    })
}



